let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2K71g")).then(() => parcelRequire('8F76Q'));